/**
 * Cliente HTTP de la API. Envía siempre la cabecera anti-CSRF y la cookie
 * de sesión (mismo origen).
 */
export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
  ) {
    super(`${status} ${code}`);
  }
}

export class NetworkError extends Error {}

export async function api<T>(path: string, init: { method?: string; body?: unknown; signal?: AbortSignal } = {}): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`/api${path}`, {
      method: init.method ?? (init.body !== undefined ? 'POST' : 'GET'),
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-HabitOS': '1' },
      body: init.body !== undefined ? JSON.stringify(init.body) : undefined,
      signal: init.signal,
    });
  } catch (err) {
    throw new NetworkError(String(err));
  }
  const text = await res.text();
  let data: unknown;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = null;
  }
  if (!res.ok) {
    // Un proxy sin API (servidor de vista previa sin backend) devuelve HTML: se trata como red.
    if (data === null && res.status >= 500) throw new NetworkError(`HTTP ${res.status}`);
    throw new ApiError(res.status, (data as { error?: string } | null)?.error ?? `http_${res.status}`);
  }
  return data as T;
}
